import { manufactureConstants } from "../../constants";

const defaultState = {
  items: [],
  item: {},
  loadingItems: false,
  loadingItem: false,
  fetchedItems: false,
  fetchedItem: false,
  error: null
};
const formatUserName = (user) => {
  if (!user) return null;
  if (typeof user === 'object') {
    return `${user.firstName || ''} ${user.lastName || ''}`.trim();
  }
  return user;
};

function normalData(arr) {
  if (!Array.isArray(arr)) return []

  return arr.map((elem, index) =>
    Object.assign(elem, {
      dateStart: elem.dateStart ? new Date(elem.dateStart) : null,
      dateFinish: elem.dateFinish ? new Date(elem.dateFinish) : null,
      index: (index + 1),
      id: elem.id,
      name: elem.name,
      nameNomenclature: elem.nomenclatureProduction?.nameNomenclature,
      nomenclatureId: elem.nomenclatureProduction.id,
      nameCategory: elem.nomenclatureProduction?.category?.nameCategory,
      characteristicId: elem.characteristic?.id ?? null,
      nameCharacteristic: elem.characteristic?.name ?? null,
      nomenclatureWithCharacteristic: `${elem.nomenclatureProduction?.nameNomenclature || ""}${elem.characteristic?.name ? ` (${elem.characteristic.name})` : ""}`,
      hasFractional: elem.nomenclatureProduction.hasFractional,
      countRows: elem.countRows,
      storageId: elem.storage?.id ?? null,
      storageLabel: elem.storage?.nameStorage ?? "—",
      items: elem.items,
      dateCreate: elem.dateCreate ? new Date(elem.dateCreate) : null,
      whoCreated: formatUserName(elem.whoCreated),
      whoUpdated: formatUserName(elem.whoUpdated),
    }))
}

function normalItem(item) {
  return {
    ...item,
    characteristicId: item.characteristic?.id ?? null,
  };
}

export const equipmentReducer = function (state = defaultState, action) {
  switch (action.type) {
    case manufactureConstants.GETALL_REQUEST_EQUIPMENT:
      return {
        ...state,
        item: {},
        loadingItems: true,
        loadingItem: false,
        fetchedItems: false,
        fetchedItem: false,
        error: null
      };
    case manufactureConstants.GETALL_SUCCESS_EQUIPMENT:
      return {
        ...state,
        items: normalData(action.response),
        loadingItems: false,
        fetchedItems: true,
      };
    case manufactureConstants.GETALL_FAILURE_EQUIPMENT:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: true,
        error: action.error,
      };
    case manufactureConstants.RESET_ITEM_EQUIPMENT:
      return {
        ...state,
        item: {},
        fetchedItem: false,
        loadingItem: false,
        error: null
      };

    case manufactureConstants.GETBYID_REQUEST_EQUIPMENT:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case manufactureConstants.GETBYID_SUCCESS_EQUIPMENT:
      const existingItem = state.items.find(item => item.id === action.response.id && item.viewStatus?.status !== action.response?.viewStatus?.status);
      if (existingItem) {
        // Обновляем существующий элемент в общем списке
        return {
          ...state,
          items: state.items.map(item => {
            if (item.id !== action.response.id) {
              return item;
            }
            item.whoCreated = action.response?.whoCreated?.firstName + " " + action.response?.whoCreated?.lastName;
            item.viewStatus = action.response?.viewStatus;
            return item;
          }),
          item: action.response,
          loadingItem: false,
          fetchedItem: true,
        };
      } else {
        return {
          ...state,
          item: action.response,
          loadingItem: false,
          fetchedItem: true,
        };
      };
    case manufactureConstants.GETBYID_FAILURE_EQUIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case manufactureConstants.CREATE_REQUEST_EQUIPMENT:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case manufactureConstants.CREATE_SUCCESS_EQUIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        item: normalItem(action.response),
        items: normalData(state.items.concat(action.response)),
        error: null
      };
    case manufactureConstants.CREATE_FAILURE_EQUIPMENT:
      console.log('action.error:', action.error);
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };
    case manufactureConstants.UPDATE_REQUEST_EQUIPMENT:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case manufactureConstants.UPDATE_SUCCESS_EQUIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        item: action.response,
        items: normalData(state.items.map((elem) => {
          if (elem.id === action.response.id) return Object.assign(elem, { ...action.response })
          return elem
        }))
      };
    case manufactureConstants.UPDATE_FAILURE_EQUIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case manufactureConstants.ARCHIVE_REQUEST_EQUIPMENT:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case manufactureConstants.ARCHIVE_SUCCESS_EQUIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        items: normalData(state.items.map((elem) => {
          if (elem.id === action.id) return Object.assign(elem, { ...action.response, isArchive: !elem.isArchive })
          return elem
        }))
      };
    case manufactureConstants.ARCHIVE_FAILURE_EQUIPMENT:
      return {
        ...state,
        loadingItem: false,
        error: action.error,
      };
    case manufactureConstants.DELETE_REQUEST_EQUIPMENT:
      return {
        ...state,
        item: {},
        loadingItems: true,
        loadingItem: false,
        fetchedItems: false,
        fetchedItem: false,
        error: null
      };
    case manufactureConstants.DELETE_SUCCESS_EQUIPMENT:
      return {
        loadingItems: false,
        fetchedItems: true,
        items: normalData(state.items.filter((elem) => elem.id !== action.id)),
      };
    case manufactureConstants.DELETE_FAILURE_EQUIPMENT:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: false,
        error: action.error,
      };
    default:
      return state;
  }
}